// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"72945008","372":"17ebf006","435":"ae28d89e","562":"746c893c","701":"3ff62ecb","730":"e72c789c","768":"7038887d","778":"31c78203"}[chunkId] + ".chunk.js";
};